import { createIntl, createIntlCache } from 'react-intl';

let intl;

// This allows us to translate text outside of Reacts context, like in redux
// Creating a cache is optional but highly recommended since it prevents memory leak
const cache = createIntlCache();

export const setIntlMessages = (messages) => {
    intl = createIntl(
        {
            locale: window.__SITE_LANGUAGE_CODE__,
            messages,
        },
        cache,
    );
};

export const translate = (message) => intl.formatMessage(message);
